import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { TrackAuthority } from '../models/trackauthority';
import { ChangeRequest } from '../models/changerequest';
import { EICSTatus } from '../models/eic-status.enum';
import { ChangeRequestType } from '../models/change-request-type.enum';

@Injectable()
export class DataShareService {
  private intialSelectedAuthority = new BehaviorSubject(null);
  authorityData = this.intialSelectedAuthority.asObservable();

  private intialRejectedAuthorityNotification = new BehaviorSubject(null);
  rejectedAuthorityNotificationData = this.intialRejectedAuthorityNotification.asObservable();

  updateAuthority(authorityHistroy: TrackAuthority) {
    this.intialSelectedAuthority.next(authorityHistroy);
  }
  updateNotification(userNotification: any[]) {
    if (userNotification.length > 0) {
      this.intialRejectedAuthorityNotification.next(userNotification);
    }
  }

  public getNameByFirstAndLastName(fullName: String): String {
    if (!fullName) {
      return '';
    }
    let names = fullName.split(',');
    return names.length > 1 ? names[1] + ' ' + names[0] : fullName;
  }

  setEICStatus(authority: TrackAuthority, changeRequest: ChangeRequest, status: EICSTatus) {
    authority.employeeInCharges.map(eic => {
      if (eic.eicUserId === changeRequest.sharingChangeModel.secondaryEICRacf) {
        eic.status = status;
      }
    });
  }
  setModifyOrReportByChangeRequestStatus(trackAuthority: TrackAuthority, authorityChangeRequestStatus: string) {
    for (let i = 0; i < trackAuthority.authorityChangeRequests.length; i++) {
      if (
        trackAuthority.authorityChangeRequests[i].type !== ChangeRequestType.SHARE &&
        trackAuthority.authorityChangeRequests[i].type !== ChangeRequestType.UNSHARE
      ) {
        trackAuthority.authorityChangeRequests[i].authorityChangeRequestStatus = authorityChangeRequestStatus;
        break;
      }
    }
  }
  setUnshareShareChangeRequestStatus(trackAuthority: TrackAuthority, authorityChangeRequestStatus: string) {
    for (let i = 0; i < trackAuthority.authorityChangeRequests.length; i++) {
      if (
        trackAuthority.authorityChangeRequests[i].type === ChangeRequestType.SHARE ||
        trackAuthority.authorityChangeRequests[i].type === ChangeRequestType.UNSHARE
      ) {
        trackAuthority.authorityChangeRequests[i].authorityChangeRequestStatus = authorityChangeRequestStatus;
        break;
      }
    }
  }
}
